import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { BRAND_TOKENS, brandTokens } from '@pqrs/contracts';
import { publicBrandingQuery } from '@/api/branding';
import { getThemeMode, THEME_EVENT } from './theme';

/**
 * Viste el backoffice con el color de la entidad (Configuración › Entidad): sobrescribe en `<html>` los tokens de
 * `tema.css` que derivan del color principal (`brandTokens`, los mismos que usa el portal), en claro y en oscuro.
 * Sin color, quedan los de Xiltrion.
 */
export function applyBrandColor(primary: string | null) {
  const root = document.documentElement.style;
  if (!primary) {
    for (const t of BRAND_TOKENS) root.removeProperty(t);
    return;
  }
  for (const [t, v] of Object.entries(brandTokens(primary, getThemeMode()))) root.setProperty(t, v);
}

/** Aplica el color de la entidad en toda la app, también antes de iniciar sesión, y lo recalcula al cambiar de modo. */
export function BrandTheme() {
  const primary = useQuery(publicBrandingQuery).data?.primary ?? null;
  useEffect(() => {
    applyBrandColor(primary);
    const on = () => applyBrandColor(primary);
    window.addEventListener(THEME_EVENT, on);
    return () => window.removeEventListener(THEME_EVENT, on);
  }, [primary]);
  return null;
}
